import { useEffect } from "react";
import styles from "./PaymentStatusModal.module.scss";
import successIcon from "../../../assets/images/payment-status/success.svg";
import failedIcon from "../../../assets/images/payment-status/failed.svg";
import GlobalModalComponent from "../globalModal/GlobalModalComponent";

interface PaymentStatusModalProps {
  isOpen: boolean;
  isSuccess: boolean;
  onClose: () => void;
  onRedirect: () => void;
  translationData?: any;
  autoRedirectDelay?: number;
  errorMessage?: string;
}

const PaymentStatusModal = ({
  isOpen,
  isSuccess,
  onClose,
  onRedirect,
  translationData,
  autoRedirectDelay = 3000,
  errorMessage,
}: PaymentStatusModalProps) => {
  useEffect(() => {
    if (isOpen && isSuccess) {
      const timer = setTimeout(() => {
        onRedirect();
      }, autoRedirectDelay);

      return () => clearTimeout(timer);
    }
  }, [isOpen, isSuccess, onRedirect, autoRedirectDelay]);

  return (
    <GlobalModalComponent isOpen={isOpen} onClose={onClose}>
      <div
        className={`${styles.modal_container} ${
          isSuccess ? styles.success : styles.failed
        }`}
      >
        <div className={styles.icon_container}>
          <div
            className={`${styles.icon_circle} ${
              isSuccess ? styles.success_circle : styles.failed_circle
            }`}
          >
            <img
              src={isSuccess ? successIcon : failedIcon}
              alt={isSuccess ? "success" : "failed"}
              className={styles.status_icon}
            />
          </div>
        </div>

        <h2 className={styles.title}>
          {isSuccess
            ? translationData?.payment_success || "Ödəniş uğurla tamamlandı!"
            : translationData?.payment_error || "Ödəniş zamanı xəta baş verdi!"}
        </h2>

        <p className={styles.subtitle}>
          {isSuccess
            ? translationData?.auth_common_thank_you || "Təşəkkürlər!"
            : errorMessage || translationData?.auth_common_try_again || "Yenidən yoxlayın"}
        </p>

        <button
          className={`${styles.action_button} ${
            isSuccess ? styles.success_btn : styles.failed_btn
          }`}
          onClick={isSuccess ? onRedirect : onClose}
        >
          {isSuccess
            ? translationData?.back || "Geri dön"
            : translationData?.close || "Bağla"}
        </button>
      </div>
    </GlobalModalComponent>
  );
};

export default PaymentStatusModal;
